import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';
import getFormattedValues, { formatReceived } from 'utils/formatValues';
import { store } from 'store';

export const baseURI = 'recaudacion/tipos-de-cargo/';
export const baseURICartera = 'recaudacion/tipos-de-cargo/filtrados/';
let controller = null;

/**
 * GET Tipos de Cargos
 * @returns {Promise<object[]>}
 */
export const getTiposDeCargosLite = async (params = {}, cancelToken) => {
  try {
    const response = await API.get(`${baseURI}tipo-cargo-pagado`, { params, cancelToken });
    return response.data;
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Tipos de Cargos
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeCargos = async (params = null, filterByPeriodo = true) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    if (filterByPeriodo) {
      // eslint-disable-next-line no-param-reassign
      params.periodo_fiscal = periodoFiscalSelected?.id;
    }
    const response = await API.get(baseURI, { params });
    return {
      ...response.data,
      results: formatReceived(response.data.results),
    };
  } catch (err) {
    onError(err);
    return { results: [] };
  }
};

/**
 * GET Tipo de Cargo
 * @param {number} id
 * @returns {Promise<object>}
 */
export const getTipoDeCargo = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}`);
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return null;
  }
};
/**
 * GET Tipos de Cargos PAra Cartera
 * @returns {Promise<Array<object>>}
 */
export const getTiposDeCargosCartera = async (params = null, filterByPeriodo = true) => {
  try {
    // Cancelar petición anterior si existe
    if (controller) {
      controller.abort();
    }

    // Crear nuevo controlador
    controller = new AbortController();

    const { periodoFiscalSelected } = store.getState()?.auth;
    if (filterByPeriodo) {
      // eslint-disable-next-line no-param-reassign
      params.periodo_fiscal_id = periodoFiscalSelected?.id;
    }

    const response = await API.get(baseURICartera, {
      params,
      signal: controller.signal,
    });

    return {
      ...response.data,
      results: formatReceived(response.data.results),
    };
  } catch (err) {
    // Si el error es por cancelación, no mostrar mensaje de error
    if (err.name === 'CanceledError') {
      return { results: [] };
    }
    onError(err);
    return { results: [] };
  }
};

/**
 * POST Tipo de Cargo
  * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postTipoDeCargo = async (values) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    const formattedValues = getFormattedValues({
      ...values,
      periodo_fiscal: values?.periodo_fiscal ?? periodoFiscalSelected?.id,
    });
    const response = await API.post(baseURI, formattedValues);
    onSuccess(response, 'Agregado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Tipo de Cargo
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchTipoDeCargo = async (id, values) => {
  try {
    const { periodoFiscalSelected } = store.getState()?.auth;
    const formattedValues = getFormattedValues({
      ...values,
      periodo_fiscal: periodoFiscalSelected?.id,
    }, { clean: false });
    const response = await API.patch(`${baseURI}${id}`, formattedValues);
    onSuccess(response, 'Editado correctamente');
    return formatReceived(response.data);
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Tipo de Cargo
 * @param {number} id
 * @returns {Promise<object|boolean>}
 */
export const deleteTipoDeCargo = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
